import { combineReducers } from 'redux';

import userHashReducer from '../commonReducers/userHashReducer';
import userObjectReducer from '../commonReducers/userObjectReducer';
import userIdentityReducer from '../commonReducers/userIdentityReducer';
import communicationPreferencesReducer from '../commonReducers/communicationPreferencesReducer';
import translationDataReducer from '../commonReducers/translationDataReducer';
import configsDataReducer from '../commonReducers/configsDataReducer';
import appliancesReducer from '../commonReducers/appliancesReducer';
import queryParamsReducer from '../commonReducers/queryParamsReducer';
import herReducer from './herReducer';
import sponsoredRecoReducer from './sponsoredRecoReducer';
import spentOnApplianceReducer from './spentOnApplianceReducer';
import personalizedTipsReducer from './personalizedTipsReducer';
import shcReducer from './SHCReducer';
import fontReducer from '../commonReducers/fontReducer';
import headerReducer from './headerReducer';
import faqReducer from './faqReducer';
import footerReducer from './footerReducer';
import efficientUserReducer from './efficientUserReducer';
import hvacInsightsReducer from './hvacInsightsReducer';
import userTypeReducer from '../commonReducers/userTypeReducer';

const allReducers = combineReducers({
  userIdentityDetails: userIdentityReducer,
  userHash: userHashReducer,
  userObject: userObjectReducer,
  preferencesData : communicationPreferencesReducer,
  translationsData: translationDataReducer,
  configs: configsDataReducer,
  appliances: appliancesReducer,
  queryParams: queryParamsReducer,
  herData: herReducer,
  sponsoredReco: sponsoredRecoReducer,
  spentOnAppliance: spentOnApplianceReducer,
  personalizedTips: personalizedTipsReducer,
  shcInfo: shcReducer,
  fontData: fontReducer,
  headerData: headerReducer,
  faqData: faqReducer,
  footerData: footerReducer,
  efficientUser: efficientUserReducer,
  hvacInsights: hvacInsightsReducer,
  userTypeDetails: userTypeReducer
})

export default function getHERReducers() {
  return allReducers;
}
